module.exports = __webpack_public_path__ + "static/logo_as_black-bc629163b823da43b054e830997af16d.png";